import { render, staticRenderFns } from "./HealthCheck.vue?vue&type=template&id=767d8ab0&scoped=true"
import script from "./HealthCheck.vue?vue&type=script&lang=ts"
export * from "./HealthCheck.vue?vue&type=script&lang=ts"
import style0 from "./HealthCheck.vue?vue&type=style&index=0&id=767d8ab0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767d8ab0",
  null
  
)

export default component.exports